import { trpc } from './trpc';
import { useToast } from '@/components/ui/use-toast';

/**
 * Hook to dispatch a topic event for testing
 */
export const useDispatchEvent = () => {
  const { toast } = useToast();

  return trpc.events.dispatch.useMutation({
    onSuccess: (data) => {
      toast({
        title: 'Success',
        description: `Event "${data.eventName}" dispatched successfully`,
      });
    },
    onError: (error) => {
      toast({
        title: 'Error',
        description: error.message || 'Failed to dispatch event',
        variant: 'destructive',
      });
    },
  });
};

